const SDK_VERSION = '8.25.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
